import { useId, type RefObject } from 'react'
import { useI18n } from '../../i18n/I18nContext'
import type { TableColumn } from '../../services/tableState'
import type { TableColumnPreference } from '../../hooks/useTableColumns'
import '../../styles/tableColumns.css'

/** Native disclosure and checkboxes preserve ordinary keyboard navigation without a grid. */
export function TableColumnSettings({ columns, preference, detailsRef }: { detailsRef?: RefObject<HTMLDetailsElement | null>; columns: readonly TableColumn[]; preference: TableColumnPreference }) {
  const { t } = useI18n()
  const id = useId()
  return <details ref={detailsRef} className="table-column-settings">
    <summary>{t('Columns')}</summary>
    <fieldset disabled={!preference.enabled} aria-describedby={preference.enabled && !preference.persisted ? id : undefined}>
      <legend>{t('Visible columns')}</legend>
      {columns.map(column => <label key={column.id}>
        <input type="checkbox" checked={preference.isVisible(column.id)} disabled={column.required}
          onChange={event => preference.setVisible(column.id, event.target.checked)} />
        {t(column.label)}{column.required ? <span className="helper"> ({t('Required column')})</span> : null}
      </label>)}
      <button type="button" className="btn btn-secondary" onClick={preference.restoreDefaults}>{t('Restore default columns')}</button>
    </fieldset>
    {preference.enabled && !preference.persisted ? <p id={id} className="helper" role="status">
      {t('Column changes could not be saved in this browser.')}
    </p> : null}
  </details>
}
